import { Routes, Route, useLocation } from "react-router-dom";
import EnterName from "../pages/EnterName/EnterName";
import EnterPan from "../pages/EnterPan/EnterPan";
import PanVerify from "../pages/PanVerify/PanVerify";
import EnterAadhaar from "../pages/EnterAadhaar/EnterAadhaar";
import DigilockerVerify from "../pages/DigilockerVerify/DigilockerVerify";
import LoanPurpose from "../pages/LoanPurpose/LoanPurpose";
import LoanAmount from "../pages/LoanAmount/LoanAmount";
import Gender from "../pages/Gender/Gender";
import Marital from "../pages/Marital/Marital";
import HighestEducation from "../pages/HighestEducation/HighestEducation";
import EmployementDetails from "../pages/EmployementDetails/EmployementDetails";
import PaymentMode from "../pages/PaymentMode/PaymentMode";
import CompanyName from "../pages/CompanyName/CompanyName";
import Industry from "../pages/Industry/Industry";
import Designation from "../pages/Designation/Designation";
import MonthlyIncome from "../pages/MonthlyIncome/MonthlyIncome";
import WorkExperience from "../pages/WorkExperience/WorkExperience";
import SalaryDate from "../pages/SalaryDate/SalaryDate";
import YourResidence from "../pages/YourResidence/YourResidence";
import EnterAddress from "../pages/EnterAddress/EnterAddress";
import Finbox from "../pages/Finbox/Finbox";
import LoanApproval from "../pages/LoanApproval/LoanApproval";
import ReferenceDetails from "../pages/ReferenceDetails/ReferenceDetails";
import Selfie from "../pages/Selfie/Selfie";
import EnterBankDetails from "../pages/EnterBankDetails/EnterBankDetails";
import Emandate from "../pages/Emandate/Emandate";
import EmandateStatus from "../pages/Emandate/EmandateStatus";
import BankList from "../pages/BankList/BankList";
import Login from "../pages/Login/Login";
import NotFound from "../pages/NotFound/NotFound";
import TermsCondition from "../pages/TermsCondition/TermsCondition";
import FinboxReject from "../pages/Finbox/FinboxReject";
import Dashboard from "../pages/Dashboard/Dashboard";
import Logout from "../pages/Logout/Logout";
import ConfirmDetails from "../pages/ConfirmDetails/ConfirmDetails";
import Contact from "../pages/Contact/Contact";
import FinboxCreate from "../pages/Finbox/FinboxCreate";
import { Home } from "../pages/Home";
import { EnterMobile } from "../pages/EnterMobile";
import { EnterOTP } from "../pages/EnterOTP";
import PanNotLinked from "../pages/PanNotLinked/PanNotLinked";

import { SelectLoan } from "../pages/SelectLoan";

import useGoogleTag from "../hooks/useGoogleTag";
import Repayment from "../pages/Repayment";
import AutoLogin from "../pages/AutoLogin/AutoLogin";
import MyLoans from "../pages/MyLoan/MyLoans";
import { AutoLogoutHandler } from "../hooks/useInactivityAutoLogout";
import { isInAppWebView } from "../utils/isInAppWebView";
import { getToken } from "../utils/storage";
import Profile from "../pages/Profile/Profile";
import LoanDetails from "../pages/LoanDetails";
import RepaymentStatus from "../pages/RepaymentStatus";
import UpdateBankDetails from "../pages/UpdateBankDetails/UpdateBankDetails";
import Reloan from "../pages/Reloan";
import SelfiePermissionAllow from "../pages/Selfie/SelfiePermissionAllow";
import Stepper from "../pages/Stepper/Stepper";
import ProtectedRoute from "./ProtectedRoute";
import InstallPrompt from "../components/InstallApp/InstallPrompt";
import Hyperverge from "../pages/Selfie/Hyperverge";
import SelfieHyperverge from "../pages/Selfie/SelfieHyperverge";
import Redirection from "../pages/Redirection/Redirection";
import LmsRedirection from "../pages/LmsRedirection";
import RepaymentBankAccountDetail from "../pages/RepaymentBankAccountDetail";
import PaymentPendingStatus from "../pages/PaymentPendingStatus/PaymentPendingStatus";
import ConsentManagement from "../pages/ConsentManagement/ConsentManagement";
import ConsentHistory from "../pages/ConsentManagement/ConsentHistory";
import ReKYC from "../pages/ReKYC";

import ReKycConfirm from "../pages/ReKYC/ReKycConfirm";
import CKYCVerification from "../pages/CKYC/CKYCVerification";
import CKYCInitiateFailed from "../pages/CKYC/CKYCInitiateFailed";
import CKYCVerificationSuccess from "../pages/CKYC/CKYCVerificationSuccess";
import CKYCVerificationFailed from "../pages/CKYC/CKYCVerificationFailed";

import VideoKyc from "../pages/VKYC/VideoKyc";
import VKYCInReview from "../pages/VKYC/VKYCInReview";
import VKYCRetry from "../pages/VKYC/VKYCRetry";
import VKYCApproved from "../pages/VKYC/VKYCApproved";
import VKYCRejected from "../pages/VKYC/VKYCRejected";

export default function AppRoute() {
  const location = useLocation();
  const isWebView = !isInAppWebView();
  const token = getToken();
  useGoogleTag();

  return (
    <>
      <InstallPrompt />

      {location.pathname !== "/logout" && isWebView && token && <AutoLogoutHandler />}

      <Routes>
        <Route path="*" element={<NotFound />} />
        <Route path="/" element={<EnterMobile />} />
        <Route path="/enter-otp" element={<EnterOTP />} />
        <Route path="/home" element={<Home />} />

        <Route path="/enter-name" element={<EnterName />} />
        <Route path="/enter-your-pan" element={<EnterPan />} />
        <Route path="/pan-verify" element={<PanVerify />} />
        <Route path="/enter-aadhar" element={<EnterAadhaar />} />
        <Route path="/pan-not-linked" element={<PanNotLinked />} />

        <Route path="/digilocker-verify" element={<DigilockerVerify />} />
        <Route path="/loan-purpose" element={<LoanPurpose />} />
        <Route path="/enter-loan-amount" element={<LoanAmount />} />
        <Route path="/gender" element={<Gender />} />
        <Route path="/marital-status" element={<Marital />} />
        <Route path="/highest-education" element={<HighestEducation />} />
        <Route path="/employment-details" element={<EmployementDetails />} />
        <Route path="/payment-mode" element={<PaymentMode />} />
        <Route path="/company-name" element={<CompanyName />} />
        <Route path="/industry" element={<Industry />} />
        <Route path="/your-designation" element={<Designation />} />
        <Route path="/monthly-income" element={<MonthlyIncome />} />
        <Route path="/work-experience" element={<WorkExperience />} />
        <Route path="/salary-date" element={<SalaryDate />} />
        <Route path="/your-residence" element={<YourResidence />} />
        <Route path="/enter-address" element={<EnterAddress />} />
        <Route path="/finbox-create" element={<FinboxCreate />} />
        <Route path="/finbox" element={<Finbox />} />
        <Route path="/loan-reject" element={<FinboxReject />} />
        <Route path="/loan-approval" element={<LoanApproval />} />
        <Route path="/reference-details" element={<ReferenceDetails />} />
        <Route
          path="/selfie-verification"
          element={
            <ProtectedRoute>
              <Selfie />
            </ProtectedRoute>
          }
        />
        <Route
          path="/selfie-hyperverge"
          element={
            <ProtectedRoute>
              <SelfieHyperverge />
            </ProtectedRoute>
          }
        />
        <Route path="/hyperverge" element={<Hyperverge />} />
        <Route path="/selfie-permission" element={<SelfiePermissionAllow />} />
        <Route path="/bank-details" element={<EnterBankDetails />} />
        <Route path="/update-bank-details" element={<UpdateBankDetails />} />

        <Route path="/emandate" element={<Emandate />} />
        <Route path="/emandate-status" element={<EmandateStatus />} />

        <Route path="/bank-list" element={<BankList />} />
        <Route path="/term-condition" element={<TermsCondition />} />
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/confirm-details" element={<ConfirmDetails />} />
        <Route path="/contact-us" element={<Contact />} />

        <Route path="/auto-login" element={<AutoLogin />} />
        <Route path="/my-loan" element={<MyLoans />} />

        <Route path="/select-loan" element={<SelectLoan />} />
        <Route path="/re-payment" element={<Repayment />} />
        <Route path="/payment-status" element={<RepaymentStatus />} />
        <Route path="/loan-details" element={<LoanDetails />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/reloan" element={<Reloan />} />
        <Route path="/redirection" element={<Redirection />} />
        <Route path="/lms-redirection" element={<LmsRedirection />} />
        <Route path="/repayment-bank-account-detail" element={<RepaymentBankAccountDetail />} />
        <Route path="/payment-pending" element={<PaymentPendingStatus />} />

        <Route path="/stepper" element={<Stepper />} />
        <Route path="/consent-management" element={<ConsentManagement />} />
        <Route path="/consent-history" element={<ConsentHistory />} />
        <Route path="/re-kyc" element={<ReKYC />} />
        <Route path="/re-kyc-confirm" element={<ReKycConfirm />} />

        <Route path="ckyc-verification" element={<CKYCVerification />} />
        <Route path="ckyc-initiate-failed" element={<CKYCInitiateFailed />} />
        <Route path="ckyc-verification-success" element={<CKYCVerificationSuccess />} />
        <Route path="ckyc-verification-failed" element={<CKYCVerificationFailed />} />

        <Route path="video-kyc" element={<VideoKyc />} />
        <Route path="video-kyc-review" element={<VKYCInReview />} />
        <Route path="video-kyc-retry" element={<VKYCRetry />} />
        <Route path="video-kyc-approved" element={<VKYCApproved />} />
        <Route path="video-kyc-rejected" element={<VKYCRejected />} />
      </Routes>
    </>
  );
}
